﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';
//import * as mathjs from 'mathjs';

import tpl_index from './tpl/index.html';
import language from '../../../common/language';
import * as Entities_Empty from '../../../lib/entities/empty';

import config from '../../../common/config';

export default Marionette.LayoutView.extend({
    getTemplate: function () {
        return tpl_index();
    },
    initialize: function () {
        this.app = this.options.app;
    },
    regions: {
    },
    onBeforeShow: function () {
        var self = this;
    },
    ui: {
    },
    events: {
    },
    onRender: function () {

    },
    onAttach() {
    }
}, Backbone.Radio.Requests);